import React from 'react';
import moment from 'moment';
import { Flex, Text } from '@chakra-ui/react';
import { BsSun as SunSvg, BsMoon as MoonSvg } from 'react-icons/bs';

import formatDate from '~/utils/formatDate';

export const isStartHourNight = startHour => {
  let isNight = false;

  const startNightStart = moment(new Date(`1996-09-13 00:00:01`));
  const startNightEnd = moment(new Date(`1996-09-13 05:59:59`));

  const endNightStart = moment(new Date(`1996-09-13 17:59:59`));
  const endNightEnd = moment(new Date(`1996-09-13 23:59:59`));

  if (
    moment(new Date(`1996-09-13 ${startHour}`)).isBetween(
      startNightStart,
      startNightEnd
    ) ||
    moment(new Date(`1996-09-13 ${startHour}`)).isBetween(
      endNightStart,
      endNightEnd
    )
  ) {
    isNight = true;
  }

  return isNight;
};

export const renderTurn = vacancy => {
  const { startHour, endHour } = vacancy;

  const formattedStartHour = formatDate(`1996-09-13 ${startHour}`).hours();
  const formattedEndHour = formatDate(`1996-09-13 ${endHour}`).hours();

  const isNight = isStartHourNight(startHour);

  return (
    <Flex alignItems="center">
      <Flex
        mr={2}
        fontSize="24px"
        color={isNight ? 'var(--dark-gray)' : 'var(--yellow)'}
      >
        {isNight ? <MoonSvg /> : <SunSvg />}
      </Flex>
      <Flex flexDir="column">
        <Text fontWeight="semibold" mb={1}>
          {vacancy.date
            .split('-')
            .reverse()
            .join('/')}
        </Text>
        <Text>{`${formattedStartHour} às ${formattedEndHour}`}</Text>
      </Flex>
    </Flex>
  );
};
